import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import InsightsFeedScreen from '../screens/Insights/InsightsFeedScreen';
import BookDetailScreen from '../screens/Book/BookDetailScreen';
import InsightDetailScreen from '../screens/Book/InsightDetailScreen';
import BookReaderScreen from '../screens/Book/BookReaderScreen';
import { FireInsight } from '../models/FirestoreModels';

export type InsightsStackParamList = {
  InsightsFeed: undefined;
  BookDetail: { 
    bookId: string; 
    languageCode?: string;
    fromRoute?: string;
  };
  InsightDetail: { 
    insights: FireInsight[];
    book?: any;
    bookTitle?: string;
    bookCoverUrl?: string;
    currentIndex: number;
    isMixedInsights?: boolean;
    fromRoute?: string;
  };
  BookReader: {
    // Option 1: Book mode
    bookId?: string;
    languageCode?: string;
    includeIntroduction?: boolean;
    // Option 2: Collection mode (IDs)
    insightIds?: string[];
    // Option 3: Direct insights (for feeds)
    insights?: FireInsight[];
    isMixedInsights?: boolean;
    // Navigation
    currentIndex?: number;
    fromRoute?: string;
    autoPlayAudio?: boolean; // For Listen action
  };
};

const Stack = createStackNavigator<InsightsStackParamList>();

const InsightsStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="InsightsFeed" 
        component={InsightsFeedScreen}
        options={{ 
          title: 'Steps',
        }} 
      />
      <Stack.Screen 
        name="BookDetail" 
        component={BookDetailScreen}
        options={{ 
          presentation: 'modal',
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: true,
        }} 
      />
      <Stack.Screen 
        name="InsightDetail" 
        component={InsightDetailScreen}
        options={{ 
          presentation: 'modal',
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: true,
        }} 
      />
      <Stack.Screen 
        name="BookReader" 
        component={BookReaderScreen}
        options={{ 
          presentation: 'modal',
          cardStyle: { backgroundColor: 'transparent' },
          animationEnabled: true,
        }} 
      />
    </Stack.Navigator>
  );
};

export default InsightsStackNavigator;

